import axios from 'axios'
import {load_many, remove, update} from '@/store/action-helpers'

// noinspection JSUnusedGlobalSymbols
export default {

    loadAllByProductId: load_many('products/files', { params: { product: ':productId' } }),

    async create({ dispatch }, { model }) {
        // Speichern
        const response = await axios.post('/api/v1/products/files', model)

        // Dateien laden
        return Promise.all([
            dispatch('loadAllByProductId', { productId: model.product, force: true }),
            dispatch('files/loadOne', { id: response.data.file }, { root: true })
        ])
    },

    remove: remove('products/files'),
    update: update('products/files/:id', { skipRefresh: true }),

}
